export default __webpack_public_path__ + "svg/who/ES_Co-fundedbytheEU_RGB_BLACK Outline.svg?7ca1ea01";